module.exports = __webpack_public_path__ + "img/mapa_pt (2).dc18672a.jpg";